import React from 'react'
import styled from 'styled-components'

const StyledHtmlContent = styled.div`
  word-break: break-all;
  font-size: 14px;
  line-height: 20px;
  img {
    max-width: 100%;
  }
  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid ${props => props.theme['neutral-500']};

    tbody td {
      border: 1px solid ${props => props.theme['neutral-500']};
      overflow: visible;
      cursor: text;
      padding: 6px;
    }
  }
`

export const HtmlContent: React.FC<{
  data: string
  style?: React.CSSProperties
  className?: string
}> = ({ data, style, className }) => {
  return (
    <StyledHtmlContent
      style={style}
      className={className}
      dangerouslySetInnerHTML={{
        __html: data,
      }}
    ></StyledHtmlContent>
  )
}
